import React from 'react';
import PropTypes from 'prop-types';

const CardAgent = ({
  id,
  title,
  subtitle,
  features,
  description,
  image,
  isSelected,
  onSelect
}) => {
  return (
    <div
      onClick={() => onSelect(id)}
      className="tw-cursor-pointer tw-transition-all tw-flex tw-justify-center"
      style={{
        width: '100%',
      }}
    >
      <div
        className="tw-bg-gradient-to-b tw-border tw-border-blue-500 tw-border-solid tw-flex tw-flex-col tw-items-center tw-justify-start tw-overflow-hidden tw-pb-4 tw-pt-4 tw-px-6 tw-relative tw-rounded-lg tw-cursor-pointer hover:tw-shadow-lg"
        style={{
          background: "linear-gradient(180deg, #FFFFFF 55.1%, #EAFEFF 100%)",
          borderRadius: '12px',
          borderWidth: '1px',
          borderColor: isSelected ? '#198FCC' : '#D6DCE1',
          width: '100%',
          maxWidth: '300px',
          height: 'auto'
        }}
      >
        <div
          style={{
            position: 'absolute',
            width: '160px',
            height: '160px',
            background: 'linear-gradient(180deg, #5BEEFF 0%, #CBFBFF 0%)',
            borderRadius: '50%',
            bottom: '30px',
            left: '50%',
            transform: 'translate(-50%, 80%)',
            zIndex: 0
          }}
        />

        <div
          className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-w-full"
          style={{ maxWidth: '222px', marginBottom: '8px', zIndex: 1 }}
        >
          <p
            className="tw-font-bold tw-text-blue-500 tw-text-2xs tw-leading-4"
            style={{ fontFamily: 'Poppins', fontSize: '11px', lineHeight: '16px' }}
          >
            {title}
          </p>
          <p
            className="tw-font-medium tw-text-gray-950 tw-text-sm tw-leading-6 tw-w-full"
            style={{ fontFamily: 'Poppins', fontSize: '14px', lineHeight: '24px', marginTop: '-2px' }}
          >
            {subtitle}
          </p>
          {features ? (
            <ul
              className="tw-list-disc tw-pl-4 tw-m-0 tw-text-gray-950 tw-text-xs tw-leading-4 tw-w-full"
              style={{ fontFamily: 'Poppins', fontSize: '12px', lineHeight: '16px' }}
            >
              {features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          ) : (
            <p
              className="tw-text-gray-950 tw-text-xs tw-leading-4 tw-w-full"
              style={{ fontFamily: 'Poppins', fontSize: '12px', lineHeight: '16px' }}
            >
              {description}
            </p>
          )}
        </div>

        <div
          className="tw-relative tw-w-40 tw-mt-auto tw-h-40"
          style={{ zIndex: 1 }}
        >
          <img
            alt=""
            className="tw-absolute tw-inset-0 tw-max-w-none tw-object-contain tw-pointer-events-none tw-w-full"
            style={{ height: 'auto', maxHeight: '160px' }}
            src={image}
          />
        </div>

        <div
          className="tw-absolute tw-right-3 tw-top-3 tw-overflow-hidden tw-w-6 tw-h-6"
        >
          <div
            className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center"
            style={{
              background: isSelected ? '#198FCC' : '#D6DCE1',
              borderRadius: '50%'
            }}
          >
            {isSelected && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="white"
                className="tw-w-4 tw-h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CardAgent.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string),
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default CardAgent;
